__turbopack_context__.v({
  "overlay": "PixelWipeLoader-module__Pt4Juq__overlay",
  "pixel-wipe-failsafe": "PixelWipeLoader-module__Pt4Juq__pixel-wipe-failsafe",
});
